export default "__VITE_ASSET__D_p5ctD0__"